import { baseUrl } from '../../../network'

export const companyEmployeeExpensesReportUrl = (companyId: number) => baseUrl + `api/company/${companyId}/employee_expenses/report`
export const companyBillsExpensesReportUrl = (companyId: number) => baseUrl + `/api/company/${companyId}/bills_expenses/report`
export const companyBillsIncomesReportUrl = (companyId: number) => baseUrl + `/api/company/${companyId}/bills_incomes/report`